<template>
  <b-container fluid>
    <!-- Search Form -->
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('grant_registration.registration_approval') }}</h4>
      </template>
      <template v-slot:body>
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
          <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset">
            <b-row>
              <b-col xl="6" lg="6" sm="12">
                  <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                      <b-form-group
                          class="row"
                          label-cols-sm="3"
                          label-for="fiscal_year_id"
                          slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                          {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                          plain
                          v-model="search.fiscal_year_id"
                          :options="fiscalYearList"
                          id="fiscal_year_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                      >
                      <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                          {{ errors[0] }}
                      </div>
                      </b-form-group>
                  </ValidationProvider>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-form-group
                class="row"
                label-cols-md="12"
                label-cols-lg="3"
                  :label="$t('grant_budget_management.organization')"
                  label-for="org_id"
                >
                  <b-form-select
                    plain
                    v-model="search.org_id"
                    :options="orgList"
                    id="org_id"
                  >
                  <template v-slot:first>
                      <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                  </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                <b-form-group
                class="row"
                label-cols-md="12"
                label-cols-lg="3"
                :label="$t('grant_config.service_type')"
                label-for="service_type_list"
                >
                  <b-form-select
                    plain
                    v-model="search.service_type_id"
                    :options="serviceTypeList"
                    id="service_type_list"
                    >
                    <template v-slot:first>
                    <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="12" md="6" lg="6" xl="6">
                  <b-form-group
                  class="row"
                  label-cols-md="12"
                label-cols-lg="3"
                  :label="$t('grant_config.service_name')"
                  label-for="service_list"
                  >
                    <b-form-select
                      plain
                      v-model="search.service_list_id"
                      :options="serviceList"
                      id="service_list"
                      >
                      <template v-slot:first>
                      <b-form-select-option :value="0" >{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col class="text-right">
              <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
              </b-col>
            </b-row>
          </b-form>
        </ValidationObserver>
      </template>
    </iq-card>
    <!-- /Search Form -->

    <!-- Table/List -->
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('grant_registration.registration_approval') + ' ' + $t('globalTrans.list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table-simple  bordered small  aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <thead class="bg-primary">
                        <b-tr>
                          <b-th class="text-center">{{ $t('globalTrans.sl_no') }}</b-th>
                          <b-th class="text-center">{{ $t('globalTrans.organization') }}</b-th>
                          <b-th class="text-center">{{ $t('grant_config.service_type') }}</b-th>
                          <b-th class="text-center">{{ $t('grant_config.service_name') }}</b-th>
                          <b-th class="text-center">{{ $t('grant_registration.institution_name') }}</b-th>
                          <b-th class="text-center">{{ $t('grant_registration.application_type') }}</b-th>
                          <b-th class="text-center">{{ $t('globalTrans.status') }}</b-th>
                          <b-th class="text-center">{{ $t('grant_registration.created') }}</b-th>
                          <b-th class="text-center">{{ $t('globalTrans.action') }}</b-th>
                        </b-tr>
                    </thead>
                    <tbody>
                      <b-tr v-for="(item, index) in listData" :key="index" :style="{ backgroundColor: today > item.committee_approval_date ? '#ff000091' : '' }">
                          <td class="text-center">{{ $n(index + 1) }}</td>
                          <td class="text-center ">{{ item.org_name_bn }}</td>
                          <td class="text-center ">{{ item.service_type_bn }}</td>
                          <td class="text-center ">{{ item.service_name_bn }}</td>
                          <td class="text-center ">{{ item.ins_name_bn }}</td>
                          <td class="text-center ">{{ item.application_type_bn }}</td>
                          <td class="text-center ">
                            <span class="badge badge-success" v-if="item.regi_status == 1">{{$t('globalTrans.verified')}}</span>
                            <span class="badge badge-success" v-else>{{$t('globalTrans.approved')}}</span>
                          </td>
                          <!-- <td class="text-center ">{{ item.created_time }}</td> -->
                          <td class="text-center ">{{ item.created_at | dateFormat }}</td>
                          <td class="text-center "><a href="javascript:" class="btn_table_action btn_green" title="View Details" v-b-modal.modal-2 @click="view(item)"><i class="fas fa-eye m-0"></i></a>
                            <a href="javascript:" class="btn_table_action btn_purple" v-if="item.regi_status == 1" :title="$t('globalTrans.approve')" v-b-modal.modal-approve @click="view(item, 'approve')"><i class="ri-check-fill m-0"></i></a>
                            <b-button v-if="$store.state.Auth.authUser.ssoLogin" style="font-size: 12px !important" variant="btn btn-xs btn-success" size="sm" @click="finalSave(item)" ><i class="fa fa-forward"></i> {{$t('globalTrans.to_nothi')}}</b-button>
                            <a href="javascript:" v-if="item.regi_status == 1" class="btn_table_action btn_deep_blue" v-b-modal.modal-3 :title="$t('grant_process.review')" @click="reView(item.id)"><i class="ri-reply-line m-0"></i></a>
                          </td>
                      </b-tr>
                    </tbody>
                  </b-table-simple>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- Table/List -->
    <b-modal id="modal-2" size="xl" :title="ViewTitle"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="editItemId" :key="editItemId"/>
    </b-modal>
      <b-modal id="modal-approve" size="lg" :title="approveTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <approveModal :id="editItemId" :key="editItemId" />
      </b-modal>
    <b-modal id="modal-3" size="lg" :title="$t('grant_process.review_note')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
        <review-form :id="application" @load-list="loadData"/>
    </b-modal>
  </b-container>
</template>
<script>
import approveModal from './approveModal'
import Details from './Details'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { applicationListApi, sendToVerifyReviewApi, registrationApprovalNothi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import ReviewForm from './Review'
import moment from 'moment'
import Store from '@/store'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    Details, approveModal, ReviewForm, ValidationObserver, ValidationProvider
  },
  data () {
    return {
      editItemId: 0,
      search: {
        service_type_id: 0,
        service_list_id: 0,
        org_id: 0,
        fiscal_year_id: 0,
        fis_start_date: '',
        fis_end_date: '',
        is_send: 1,
        is_verified: 1
      },
      application: '',
      today: new Date().toISOString().split('T')[0],
      url: grantAllowanceServiceBaseUrl,
      serviceList: [],
      rows: []
    }
  },
  computed: {
    fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    approveTitle () {
       return this.$t('grant_registration.review_and_verfication_management') + ' ' + this.$t('globalTrans.approve')
    },
    orgList () {
        return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
     serviceTypeList: function () {
        const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    ViewTitle () {
       return this.$t('grant_registration.review_and_verfication_management') + ' ' + this.$t('globalTrans.details')
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  watch: {
    'search.service_type_id': function (newVal) {
      this.serviceList = this.getServiceList()
    },
    'search.fiscal_year_id': function (newVal, oldVal) {
        if (newVal !== 0) {
          const fiscalYearId = parseInt(newVal)
          const fiscalYear = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
          this.search.fiscal_year_id = fiscalYear.value
          this.search.fis_start_date = fiscalYear.start_date
          this.search.fis_end_date = fiscalYear.end_date
       } else {
          this.search.fiscal_year_id = 0
          this.search.fis_start_date = ''
          this.search.fis_end_date = ''
       }
    },
    '$i18n.locale': function (newValue) {
        this.serviceList = this.getServiceList()
    }
  },
   created () {
        this.loadData()
    },
  mounted () {
  },
  methods: {
    searchData () {
      this.loadData()
    },
    edit (item) {
      this.editItemId = item.id
    },
    reView (row) {
      this.application = row
    },
    view (item) {
      this.editItemId = item.id
    },
    remove (item) {
      this.changeStatus(grantAllowanceServiceBaseUrl, item)
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(grantAllowanceServiceBaseUrl, applicationListApi, params).then(response => {
          if (response.success) {
              this.$store.dispatch('setList', this.getRelationalData(response.data.data))
              this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
          const listData = data.map(item => {
            const tmpOrg = this.$store.state.orgList.find(org => org.status === 0 && org.value === item.org_id)
            const tmpServiceType = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList.find(service => service.value === item.service_type_id)
            const tmpServiceName = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.find(service => service.status === 0 && service.value === item.service_id)
            const tmpFiscalYear = this.$store.state.commonObj.fiscalYearList.find(fiscalYear => fiscalYear.status === 0 && fiscalYear.value === item.fiscal_year_id)
            const tmpApplicationType = this.$store.state.commonObj.applicationTypeList.find(type => type.value === parseInt(item.application_type))
            const divList = this.$store.state.commonObj.divisionList.find(div => div.value === item.division_id)
            const disList = this.$store.state.commonObj.districtList.find(dis => dis.value === item.district_id)
            const upaList = this.$store.state.commonObj.upazilaList.find(upa => upa.value === item.upazilla_id)
            const unionList = this.$store.state.commonObj.unionList.find(union => union.value === item.union_id)
            const cityCorList = this.$store.state.commonObj.cityCorporationList.find(city => city.value === item.city_corporation_id)
            const pauroList = this.$store.state.commonObj.pauroshobaList.find(pauro => pauro.value === item.pauroshoba_id)
            const wardList = this.$store.state.commonObj.wardList.find(ward => ward.value === item.ward_id)
            const officeTypeList = this.$store.state.commonObj.officeTypeList.find(officeType => officeType.value === item.office_type_id)
            const officeList = this.$store.state.commonObj.officeList.find(office => office.value === item.office_id)
            const tmpCreatedTime = moment(item.updated_at).startOf('minute').fromNow()

            const newData = {
                org_name: tmpOrg !== undefined ? tmpOrg.text_en : '',
                org_name_bn: tmpOrg !== undefined ? tmpOrg.text_bn : '',
                service_type: tmpServiceType !== undefined ? tmpServiceType.text_en : '',
                service_type_bn: tmpServiceType !== undefined ? tmpServiceType.text_bn : '',
                service_name: tmpServiceName !== undefined ? tmpServiceName.text_en : '',
                service_name_bn: tmpServiceName !== undefined ? tmpServiceName.text_bn : '',
                fiscal_name: tmpFiscalYear !== undefined ? tmpFiscalYear.text_en : '',
                fiscal_name_bn: tmpFiscalYear !== undefined ? tmpFiscalYear.text_bn : '',
                application_type_en: tmpApplicationType !== undefined ? tmpApplicationType.text_en : '',
                application_type_bn: tmpApplicationType !== undefined ? tmpApplicationType.text_bn : '',
                created_time: tmpCreatedTime !== undefined ? tmpCreatedTime : '',
                select: '1',
                div_name: divList !== undefined ? divList.text_en : '',
                div_name_bn: divList !== undefined ? divList.text_bn : '',
                dis_name: disList !== undefined ? disList.text_en : '',
                dis_name_bn: disList !== undefined ? disList.text_bn : '',
                upazilla_name: upaList !== undefined ? upaList.text_en : '',
                upazilla_name_bn: upaList !== undefined ? upaList.text_bn : '',
                union_name: unionList !== undefined ? unionList.text_en : '',
                union_name_bn: unionList !== undefined ? unionList.text_bn : '',
                cityCorporation_name: cityCorList !== undefined ? cityCorList.text_en : '',
                cityCorporation_name_bn: cityCorList !== undefined ? cityCorList.text_bn : '',
                pauroshoba_name: pauroList !== undefined ? pauroList.text_en : '',
                pauroshoba_name_bn: pauroList !== undefined ? pauroList.text_bn : '',
                ward_name: wardList !== undefined ? wardList.text_en : '',
                ward_name_bn: wardList !== undefined ? wardList.text_bn : '',
                office_type_bn: officeTypeList !== undefined ? officeTypeList.text_bn : '',
                office_bn: officeList !== undefined ? officeList.text_bn : ''
            }
            return Object.assign({}, item, newData)
          })
          return listData
    },
    getServiceList () {
      const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.service_type_id === this.search.service_type_id && item.has_public_form === 1 && item.has_public_form === 1)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    send () {
      const newArray = this.$store.state.list.filter(item => item.select === '1').map((itm) => {
        return { id: itm.id, select: itm.select }
      })
      if (newArray.length > 0) {
            window.vm.$swal({
              title: window.vm.$t('grant_registration.review_and_verify_msg'),
              showCancelButton: true,
              confirmButtonText: window.vm.$t('globalTrans.yes'),
              cancelButtonText: window.vm.$t('globalTrans.no'),
              focusConfirm: false
          }).then((result) => {
              if (result.isConfirmed) {
                  this.$store.dispatch('mutateCommonProperties', { loading: true })
                  const loadingState = { loading: false, listReload: true }
                  RestApi.postData(grantAllowanceServiceBaseUrl, sendToVerifyReviewApi, { ids: newArray }).then(response => {
                  this.$store.dispatch('mutateCommonProperties', loadingState)
                      if (response.success) {
                          this.$toast.success({
                              title: this.$t('globalTrans.success'),
                              message: this.$t('globalTrans.update_msg'),
                              color: '#D6E09B'
                          })
                      } else {
                          this.$toast.error({
                              title: this.$t('globalTrans.error'),
                              message: 'Operation failed! Please, try again.'
                          })
                      }
                  })
              }
          })
      } else {
        this.$toast.error({
            title: this.$t('globalTrans.error'),
            message: this.$i18n.locale === 'bn' ? 'অন্তত একটি আইটেম নির্বাচন করুন..!' : 'Select at least one item..!'
        })
      }
    },
      finalSave (item) {
        this.toggleStatusCustom2(grantAllowanceServiceBaseUrl, registrationApprovalNothi, item)
      },
      toggleStatusCustom2 (baseUrl, uri, item) {
        window.vm.$swal({
          title: window.vm.$t('globalTrans.are_you_sure_forward_to_nothi'),
          showCancelButton: true,
          confirmButtonText: window.vm.$t('globalTrans.yes'),
          cancelButtonText: window.vm.$t('globalTrans.no'),
          focusConfirm: false
        }).then((result) => {
          if (result.isConfirmed) {
            this.changeStatusCustom(baseUrl, uri, item)
          }
        })
      },
      changeStatusCustom (baseUrl, uri, item) {
        Store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
        RestApi.postData(baseUrl, uri, item).then(response => {
          if (response.success) {
            window.vm.$toast.success({
              title: 'Success',
              message: 'Data Updated Successfully',
              color: '#D6E09B'
            })
          } else {
            window.vm.$toast.error({
              title: 'Error',
              message: 'Operation failed! Please, try again.'
            })
          }
          Store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
        })
      }
  }
}
</script>
